import { render, staticRenderFns } from "./TheMarquee.vue?vue&type=template&id=50f50de2&scoped=true&"
import script from "./TheMarquee.vue?vue&type=script&lang=js&"
export * from "./TheMarquee.vue?vue&type=script&lang=js&"
import style0 from "./TheMarquee.vue?vue&type=style&index=0&id=50f50de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f50de2",
  null
  
)

export default component.exports